import React from 'react'
import values from 'mout/object/values'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText'
import { AnswerKeyColumn } from './'

export default function AnswerKey({answers, answersByItem, byItem}) {
  const items = sortByPropText(values(byItem), 'index')
  const perColumn = Math.ceil(items.length / 3)
  const itemsCol1 = items.splice(0, perColumn)
  const itemsCol2 = items.splice(0, Math.ceil(items.length / 2))
  const itemsCol3 = items.slice(0)
  return (
    <div className="answer-key">
      <h5>Answer Key</h5>
      <AnswerKeyColumn
        number='1'
        answers={answers}
        answersByItem={answersByItem}
        items={itemsCol1}
        startNumber='1'
      />
      <AnswerKeyColumn
        number='2'
        answers={answers}
        answersByItem={answersByItem}
        items={itemsCol2}
        startNumber={itemsCol1.length + 1}
      />
      <AnswerKeyColumn
        number='3'
        answers={answers}
        answersByItem={answersByItem}
        items={itemsCol3}
        startNumber={itemsCol1.length + itemsCol2.length + 1}
      />
    </div>
  )
}

// If answer is incorrect, add class of "incorrect" to "answer-chosen" span. See question #2 for example.


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReport/AnswerKey.js